import React from "react";
import { StaticImage } from "gatsby-plugin-image";

// components
import ReusableForm from "../../Global/ReusableForm/ReusableForm";

// css
import * as styles from "./GetInTouchNew.module.css";

const GetInTouchNew = ({
  onFormSubmit,
  mixpanelPageName = "Homepage - Get In Touch Popup",
  buttonColor = "#AD2576",
  checkboxColor = "#AD2576",
  loading = false,
}) => {
  // Define form fields
  const formFields = [
    {
      name: "fullName",
      label: "Please enter your name*",
      placeholder: "Full Name*",
      type: "text",
      colSize: 12,
      validation: {
        required: "Please enter your name",
        pattern: {
          value: /^[A-Za-z\s]+$/, // eslint-disable-line no-useless-escape
          message: "Please enter a valid name",
        },
        maxLength: {
          value: 50,
          message: "Name is too long",
        },
      },
    },
    {
      name: "mobileNumber",
      label: "Please enter your mobile number*",
      placeholder: "Mobile Number*",
      type: "text",
      inputMode: "numeric",
      maxLength: 10,
      colSize: 12,
      validation: {
        required: "Please enter your mobile number",
        pattern: {
          value: /^\+?([1-9]{1})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{4})$/, // eslint-disable-line no-useless-escape
          message: "Please enter a valid mobile number",
        },
        maxLength: {
          value: 10,
          message: "Invalid mobile number",
        },
      },
    },
  ];

  // Handle form submission
  const handleFormSubmit = async data => {
    // Call parent callback if provided
    if (onFormSubmit) {
      await onFormSubmit(data);
    }
  };

  return (
    <div className={styles.getInTouchWrapper}>
      <div className="row align-items-center g-0">
        {/* Image Column */}
        <div className="col-lg-5 col-12">
          <div className={styles.imageContainer}>
            <StaticImage
              src="../../../images/home/get-in-touch-banner.png"
              alt="Twin Health - Get in touch"
              className={styles.bannerImage}
              placeholder="blurred"
              quality={90}
            />
          </div>
        </div>

        {/* Form Column */}
        <div className="col-lg-7 col-12">
          <div className={styles.formContainer}>
            <div className={styles.formHeader}>
              <h2 className={styles.mainTitle}>Get in touch</h2>
              <p className={styles.subTitle}>
                Let your remission journey begin today!
              </p>
            </div>

            <div className={styles.formContent}>
              <ReusableForm
                fields={formFields}
                onSubmit={handleFormSubmit}
                ctaText="Submit"
                loading={loading}
                mixpanelPageName={mixpanelPageName}
                formIsModal={true}
                showCheckbox={true}
                checkboxText="I agree to be contacted by Twin Health via Call, SMS, RCS, WhatsApp & Email"
                checkboxColor={checkboxColor}
                buttonStyles={{
                  backgroundColor: buttonColor,
                  width: "100%",
                  maxWidth: "200px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouchNew;
